import * as React from "react";
import Modal from "../../ui/modal/Modal";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import {api} from "../../../api/api";
import {getErrorMessage, notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {none, option, Option} from "ts-option";
import Loading from "../../ui/loading/Loading";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import {isEmail} from "../../../utils/ValidationUtils";
import TextUtils from "../../../utils/TextUtils";

const sanitizeHtml = require("sanitize-html");


interface ComponentProps {
	onCloseClicked: () => void,
	customerEmail: string
	invoiceId: string
	onSendEmail: (customerEmail: string, subject: string) => void
	isLoading: boolean
}

interface State {
	customerEmail: string;
	subject: string;
	htmlContent: Option<string>
}

type Props = ComponentProps

export default class InvoiceEmailPreviewModal extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state =
			{customerEmail: props.customerEmail, htmlContent: none, subject: ""};
	}

	componentDidMount() {
		api.instance.invoiceApi.fetchEmailPreview(this.props.invoiceId)
			.then((data) => {
				this.setState({htmlContent: option(data.html), subject: data.subject})
			})
			.catch((error) => notifyBugsnagAndShowToast(error, "Fetch invoice email preview", getErrorMessage(error)))
	}

	render() {
		const html = sanitizeHtml(TextUtils.createTextLinks(this.state.htmlContent.orNull), {
			allowedTags: ["span", "a", "div", "style", "strong", "br", "img", "button"],
			allowedAttributes: {
				"span": ["class", "style"],
				"a": ["class", "style"],
				"div": ["class", "id", "style"],
				"style": ["type"],
				"img": ["src", "width", "height", "style"],
				"button": ["style", "type"],
				"strong": ["style"]
			}
		});
		return (
			<Modal title={this.renderHeader()}
				   customClass={"invoice-email-preview-modal"}
				   mediumWidth>
				<Loading isLoading={this.state.htmlContent.isEmpty}>
					<div className={"email-content"}
						 dangerouslySetInnerHTML={{__html: html}}/>
				</Loading>
				<div className={"buttons"}>
					<ButtonSecondary label={"Cancel"}
									 onClick={this.props.onCloseClicked}/>
					<ButtonPrimary label={"Send"}
								   onClick={this.onSend}
								   isLoading={this.props.isLoading}
								   disabled={!isEmail(this.state.customerEmail) || this.props.isLoading}/>
				</div>
			</Modal>
		)
	}

	renderHeader() {
		return (
			this.state.htmlContent.isEmpty ?
				<label className={"header_label"} style={{borderBottom: "unset"}}>Email preview</label>
				:
				<div className={"header"}>
					<label className={"header_label"}>Email preview</label>
					<div className={"header_input"}>
						<div className={"header_input_label-container"}>
							<label>To</label>
						</div>
						<Input type={"email"}
							   value={this.state.customerEmail}
							   onChange={this.onEmailChange}/>
					</div>
					<div className={"header_inputs-border"}/>
					<div className={"header_input"}>
						<div className={"header_input_label-container"}>
							<label>Subject</label>
						</div>
						<Input type={"text"}
							   value={this.state.subject}
							   onChange={this.onSubjectChange}/>
					</div>
				</div>
		)
	}

	onEmailChange = (evt: React.ChangeEvent<HTMLInputElement>) => this.setState({customerEmail: evt.target.value});
	onSubjectChange = (evt: React.ChangeEvent<HTMLInputElement>) => this.setState({subject: evt.target.value});
	onSend = () => this.props.onSendEmail(this.state.customerEmail, this.state.subject);
}
